import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'
import {ILoginPayload} from '../../SERVICE-INTERFACES'

const auth_endpoints = APIS_ENDPOINTS.authentincation

export const request_login = async ({username, password}: ILoginPayload) => {
  const formdata = new FormData()
  formdata.append('UserName', username)
  formdata.append('Password', password)

  return http.post(auth_endpoints.login, formdata)
}

export const request_estateLogin = async ({username, password}: ILoginPayload) => {
  const formdata = new FormData()
  formdata.append('UserName', username)
  formdata.append('Password', password)

  return http.post(auth_endpoints.estatelogin, formdata)
}

export const request_getRoles = async () => {
  return http.get(auth_endpoints.getRoles)
}
export const request_getProfile = async () => {
  return http.get(auth_endpoints.getProfile)
}

export const request_getUsersByRole = async (RoleName: string) => {
  return http.get(
    auth_endpoints.getUsersByRole +
      `${RoleName != undefined ? `?RoleName=${RoleName}` : '?RoleName=NULL'}`
  )
}

export const request_sendsmsforacceptcontractandverify = async () => {
  return http.post(auth_endpoints.sendsmsforacceptcontractandverify)
}

export const request_acceptcontractandverify = async ({
  PhoneNumber,
  Code,
}: {
  PhoneNumber: string
  Code: string
}) => {
  const formdata = new FormData()
  formdata.append('PhoneNumber', PhoneNumber)
  formdata.append('Code', Code)

  return http.post(auth_endpoints.acceptcontractandverify, formdata)
}
